import { Component, Inject, Input } from '@angular/core';
import { Reason } from '../../../shared/models/reason.model';

@Component({
  selector: 'reasons-navigation',
  template: `
    <top-navigation [breadcrumbSteps]="steps"></top-navigation>
  `,
})

export class ReasonsNavigationComponent {
  @Input() reason: Reason;
  @Input() noForm: boolean = false;

  steps = [
    { stateName: 'patients.id.reasons', label: 'breadcrumb.steps.reasons' },
    { stateName: 'patients.id.reasons.id.patients', label: 'breadcrumb.steps.patients' },
    { stateName: 'patients.id.reasons.id.form', label: 'breadcrumb.steps.form' },
    { stateName: 'patients.id.reasons.id.preferences', label: 'breadcrumb.steps.preferences' },
  ];

  constructor(
    @Inject('ProductService') public ProductService: any,
  ) {}

  ngOnInit(): void {
    if (this.noForm || !this.ProductService.isAvailable('PATIENT_FORMS') || !this.reason.form || !this.reason.form.questionsCount) {
      this.steps.splice(2, 1);
    }

    if (!!this.reason && !this.reason.allowConsecutiveAppointments) {
      this.steps.splice(1, 1);
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reasons-navigation/reasons-navigation.component.ts